import * as Yup from 'yup';

export const AddReviewCompanyFormValidationSchema = Yup.object().shape({
  firm: Yup.object()
    .nullable()
    .required('Firm field is required'),

  rating: Yup.number()
    .nullable()
    .min(1, 'Rating is required')
    .required('Rating is required'),

  q1: Yup.string()
    .min(10, 'String is too short. Minimum length is 10 characters.')
    .max(100, 'You have exceeded the maximum number of 100 characters')
    .required('Title field is required'),

  q2: Yup.string()
    .min(10, 'String is too short. Minimum length is 10 characters.')
    .max(15000, 'You have exceeded the maximum number of 15000 characters')
    .required('This field is required'),

  q3: Yup.string()
    .min(100, 'String is too short. Minimum length is 100 characters.')
    .max(15000, 'You have exceeded the maximum number of 15000 characters')
    .required('This field is required'),

  email: Yup.string()
    .nullable()
    .max(100, 'You have exceeded the maximum number of 100 characters')
    .when(['isCandidate'], (isCandidate, schema) => {
      if (isCandidate) {
        return schema;
      }
      return schema.test(
        'required-email',
        'Email field is required',
        value => !!value
      );
    }),

  fullname: Yup.string()
    .nullable()
    .max(100, 'You have exceeded the maximum number of 100 character')
    .when(['isCandidate'], (isCandidate, schema) => {
      if (isCandidate) {
        return schema;
      }
      return schema.test(
        'required-fullname',
        'Full Name field is required',
        value => !!value
      );
    }),

  phone: Yup.string()
    .nullable()
    .max(30, 'You have exceeded the maximum number of 30 character')
    .when(['isCandidate'], (isCandidate, schema) => {
      if (isCandidate) {
        return schema;
      }
      return schema.test(
        'required-email',
        'Phone field is required',
        value => !!value
      );
    }),
});
